import axios from 'axios';
import { useMutation } from 'react-query';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';

const BASE_KEY = 'custom-order-form';

/** @type {(username: string) => Promise<any>} */
const getFormData = (username) => {
    const url = pathfinder('new_custom_order_request_form', { seller: username });
    return axios
        .get(url)
        .then((response) => response.data.data)
        .catch((error) => {
            logger.error('Failed to fetch custom order data', { error });
        });
};

/** @type {(username: string) => import('react-query').UseMutationResult<any>} */
export const useCustomOrderFormMutation = (username) => {
    const data = useMutation(() => getFormData(username), {
        mutationKey: [BASE_KEY, username],
    });
    return data;
};
